import React, { FunctionComponent } from "react"
import { FormProvider, useForm } from "react-hook-form"
import FormInput from "../../components/Form/Inputs/FormInput"
import { iArtifactQuery } from "../../definitions/Artifacts"
import { iChangeType } from "../../definitions/interfaces"
import { isAdmin } from "../../helpers/isAdmin"

interface iProps {
  setQuery: (data: iArtifactQuery) => void
  query: iArtifactQuery
}

const ArtifactsFilters: FunctionComponent<iProps> = ({ setQuery, query }) => {
  const onChange = ({ name, value }: iChangeType) => {
    setQuery({ [name]: value })
  }

  const methods = useForm({ defaultValues: query })

  return (
    <div className="filters">
      <div className="filters-form">
        <FormProvider {...methods}>
          <FormInput
            name="title"
            autoComplete="off"
            onChange={onChange}
            placeholder="Search by title..."
          />
          <FormInput
            name="culture"
            autoComplete="off"
            onChange={onChange}
            placeholder="Search by culture..."
          />
          {isAdmin() && (
            <FormInput
              autoComplete="off"
              name="public"
              label="Show Public"
              type="checkbox"
              onChange={onChange}
            />
          )}
        </FormProvider>
      </div>
    </div>
  )
}

export default ArtifactsFilters
